<template>
  <div class="content">
    <div class="text-end mb-3">
      <select
        v-model="selectedLang"
        @change="onLangChange"
        class="form-select w-auto d-inline-block"
      >
        <option v-for="lang in languages" :key="lang.code" :value="lang.code">
          {{ lang.language }}
        </option>
      </select>

      <!-- Country Select -->
      <select
        v-model="selectedCountry"
        @change="onLangOrCountryChange"
        class="form-select w-auto d-inline-block"
      >
        <option value="" disabled>Select Country</option>
        <option
          v-for="country in countries"
          :key="country.code"
          :value="country.code"
        >
          {{ country.country }}
        </option>
      </select>
    </div>
    <div class="text-end mb-2">
      <button class="btn btn-success" @click="addBanner">Add Banner</button>
    </div>
    <div class="layout">
      <div>
        <div class="container-fluid">
          <!-- Banner Management Section -->
          <div class="justify-content-center text-center">
            <div style="width: 100%">
              <div style="overflow-x: auto">
                <table class="table" style="width: 100%">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col-4">Name</th>
                      <th scope="col-4">Banner</th>
                      <th scope="col-4">Status</th>
                      <th scope="col-4"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <tr v-if="banners.length === 0"> -->
                    <tr v-if="Array.isArray(banners) && banners.length === 0">
                      <td colspan="4" class="text-center">No banners found</td>
                    </tr>
                    <tr
                      v-for="(banner, index) in banners"
                      :key="index"
                      class="align-items-center justify-content-center"
                    >
                      <td>{{ banner.name }}</td>
                      <td>
                        <img
                          :src="getBannerUrl(banner.url)"
                          alt="Banner"
                          style="width: 250px; height: auto"
                        />
                      </td>
                      <td>
                        <button
                          class="btn btn-sm"
                          :class="
                            banner.status == 1 ? 'btn-success' : 'btn-danger'
                          "
                          @click="
                            updateBannerStatus(
                              banner.id,
                              banner.status == 1 ? 0 : 1
                            )
                          "
                        >
                          {{ banner.status == 1 ? "Active" : "Inactive" }}
                        </button>
                      </td>

                      <td class="text-end">
                        <button
                          class="btn btn-danger"
                          @click="deleteBanner(banner.id)"
                        >
                          <span v-if="deleteLoading">Loading...</span>
                          <span v-else>Delete</span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Modal for Adding Banners -->
          <div v-if="showModal" class="modal">
            <div class="modal-content">
              <span
                class="close text-end text-danger"
                @click="showModal = false"
                >&times;</span
              >
              <h3>Add New Banner</h3>
              <input
                type="file"
                @change="onFileChange"
                class="form-control mb-2"
              />
              <div class="mb-2">
                <label for="status" class="form-label">Status</label>
                <select
                  id="status"
                  v-model="status"
                  class="form-select"
                  required
                >
                  <option value="" disabled>Select status</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
              <div class="text-end">
                <button
                  class="btn btn-primary"
                  @click="submitBanner"
                  :disabled="loading"
                >
                  <!-- Show spinner when loading is true -->
                  <span v-if="loading">Loading...</span>
                  <!-- Show button text when not loading -->
                  <span v-else>Upload</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../services/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      type: ["", "info", "success", "warning", "danger"],
      banners: [],
      languages: [],
      selectedImage: null,
      showModal: false,
      loading: false,
      deleteLoading: false,
      selectedLang: "en", // default language
      selectedCountry: "",
      countries: [],
      status: "1",
    };
  },
  async mounted() {
    this.getLanguages();
    await this.loadCountries();

    // Set default country if none selected
    if (!this.selectedCountry && this.countries.length > 0) {
      this.selectedCountry = this.countries[0].code;
    }
    this.getBanners(this.selectedLang, this.selectedCountry);

  },
  methods: {
    async loadCountries() {
  try {
    const response = await axios.get(`countries`, {
      headers: {
        "api-key": Cookies.get("authToken"),
      },
    });

    if (response.status === 200 && Array.isArray(response.data.countries)) {
      this.countries = response.data.countries;

      // 👇 ensure selected country exists
      if (
        !this.selectedCountry ||
        !this.countries.some(c => c.code === this.selectedCountry)
      ) {
        this.selectedCountry = this.countries[0].code;
      }
    } else {
      this.countries = [];
    }
  } catch (error) {
    this.handleError(error);
  }
},

    getBannerUrl(url) {
      if (url && !url.startsWith("https://")) {
        return `https://${url}`;
      }
      return url;
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file; // Store the selected file
      }
    },

    addBanner() {
      console.log("addBanner called"); // Check if function is called
      this.showModal = true;
      console.log("showModal set to", this.showModal); // Check value update
    },

    async submitBanner() {
      if (!this.selectedImage) {
        this.$notify({
          message: "Please select an image to upload.",
          icon: "",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        // this.loading = false;
        return;
      }

      const formData = new FormData();
      formData.append("file", this.selectedImage);
      formData.append("language", this.selectedLang);
      formData.append("country", this.selectedCountry);
      formData.append("status", this.status);

      try {
        this.loading = true;

        const response = await axios.post("banner", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": `${Cookies.get("authToken")}`, // Include the auth token
          },
        });

        if (response.status == 200) {
          this.$notify({
            message: "Successfuly uploaded",
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          this.loading = false;
          this.showModal = false;
          this.getBanners();
          this.resetForm();
        }
      } catch (error) {
        this.loading = false;

        if (error.status == 404) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          this.$router.push("/login");
          Cookies.remove("authToken");
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    resetForm() {
      this.status = "1";
      this.selectedImage = null;
      this.showModal = false; // Hide the modal
    },
    onLangOrCountryChange() {
      // Called when either language or country changes
      this.getBanners(this.selectedLang, this.selectedCountry);
    },
    async updateBannerStatus(id, newStatus) {
  try {
    const response = await axios.put(
      `banner-status/${id}`,
      { status: newStatus }, 
      {
        headers: {
          "api-key": `${Cookies.get("authToken")}`,
        },
      }
    );

    if (response.status === 200) {
      this.$notify({
        message: "Status updated successfully",
        icon: "",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });

      // Refresh banners
      this.getBanners(this.selectedLang, this.selectedCountry);
    }
  } catch (error) {
    this.$notify({
      message:
        error.response?.data?.error_message ||
        error.response?.data?.message ||
        "Failed to update status",
      icon: "",
      horizontalAlign: "right",
      verticalAlign: "top",
      type: "danger",
    });
    console.error("Error updating status:", error);
  }
},
    async getBanners(lang = this.selectedLang, country = this.selectedCountry) {
      try {
        const response = await axios.get(
          `banner?lang=${lang}&country=${country}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "api-key": `${Cookies.get("authToken")}`,
            },
          }
        );

        console.log(response);

        if (response.status == 200 && Array.isArray(response.data)) {
          this.banners = response.data;
        } else {
          this.banners = [];
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
        if (error.status == 404) {
          this.$notify({
            message:
              error.response?.data?.message ||
              error.response?.data?.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          this.$router.push("/login");
          Cookies.remove("authToken");
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    async getLanguages() {
      try {
        const response = await axios.get(`languages`, {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": `${Cookies.get("authToken")}`,
          },
        });

        console.log(response);

        if (response.status == 200 && Array.isArray(response.data.languages)) {
          this.languages = response.data.languages;
        } else {
          this.languages = [];
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
        if (error.status == 404) {
          this.$notify({
            message:
              error.response?.data?.message ||
              error.response?.data?.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          this.$router.push("/login");
          Cookies.remove("authToken");
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    onLangChange() {
      this.getBanners();
    },
    async deleteBanner(id) {
      try {
        this.deleteLoading = true;
        const response = await axios.delete(`banner/${id}`, {
          headers: {
            "api-key": `${Cookies.get("authToken")}`,
          },
        });
        console.log("DELETED DATA", response);

        if (response.status == 200) {
          // this.deleteLoading=false;
          this.$notify({
            message: "Successfuly deleted",
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          window.location.reload();
          // this.getBanners();
        }
      } catch (error) {
        // this.deleteLoading=false;
        if (error.status == 404) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          this.$router.push("/login");
          // Cookies.remove("authToken");
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
        console.error("Error deleting banner", error);
      } finally {
        this.deleteLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  width: 300px;
}
.close {
  float: right;
  cursor: pointer;
}
</style>
